import {Checkbox, Divider, ListItem, Stack, Typography} from "@mui/material";
import {LastUserLocation} from "../../../utils/models/LastUserLocation";
import {useLastUserLocations} from "../../../contexts/LastUserLocationContext";
import {useTranslation} from "react-i18next";
import moment from "moment/moment";
import {momentRelativeTimeTranslationsForLocale} from "../../../utils/helpers/datesHelper";

interface Props {
    style: any;
    lastUserLocation: LastUserLocation;
    handleToggle(id: string): any;
    checked: string[];
    index: number;
    length: number;
}

export default function LastUserLocationItem({style, lastUserLocation, handleToggle, checked, index, length}: Props) {
    const labelId = `checkbox-list-secondary-label-${lastUserLocation.personalReference}`;
    const {t, i18n} = useTranslation();

    const currentLocale = i18n.language;

    moment.locale(currentLocale, momentRelativeTimeTranslationsForLocale(currentLocale));
    const date = moment(lastUserLocation.date);

    const {
        selectedLastUserLocationMarker,
        setSelectedLastUserLocationMarker,
        zoom,
        setView
    } = useLastUserLocations();

    const getPreciseLabel = (lastUserLocation: LastUserLocation) => {
        return lastUserLocation.location.isPrecise ? t("precise_location_label") : t("not_precise_location_label");
    }

    const getItemClassName = (lastUserLocation: LastUserLocation) => {
        if (selectedLastUserLocationMarker?.personalReference === lastUserLocation.personalReference) {
            if (lastUserLocation.location.isPrecise) {
                return "dashboard-list-precise-item-active"
            }
            return "dashboard-list-not-precise-item-active";
        }
        return "";
    }

    return (
        <>
            <ListItem
                style={style}
                onClick={() => {
                    if (selectedLastUserLocationMarker && selectedLastUserLocationMarker.personalReference === lastUserLocation.personalReference) {
                        setSelectedLastUserLocationMarker(undefined);
                    } else {
                        setSelectedLastUserLocationMarker(lastUserLocation);
                        setView({
                            location: {lat: lastUserLocation.location.latitude, lng: lastUserLocation.location.longitude},
                            zoom: zoom,
                            options: {animate: true}
                        });
                    }
                }}
                sx={{
                    backgroundColor: index % 2 ? "#f5f1e9" : "white",
                    padding: 1,
                    "&.Mui-selected": {
                        backgroundColor: "#f294b4"
                    },
                    "&.Mui-focusVisible": {
                        backgroundColor: "#f294b4"
                    },
                    ":hover": {
                        backgroundColor: index % 2 ? "#f5f1e9" : "white"
                    }
                }}
                className={getItemClassName(lastUserLocation)}>
                <Stack direction={'row'} sx={{justifyContent: "space-between", width: "100%"}}>
                    <Stack direction='column'>
                        <Typography
                            variant={"body1Bold"}>
                            {lastUserLocation.userDisplayName}
                        </Typography>
                        <Typography
                            variant={"body2"}>
                            {lastUserLocation.personalReference}
                        </Typography>
                        <Stack direction='column' sx={{mt: 1}}>
                            <Typography
                                variant={"body2"}>
                                Last location
                            </Typography>
                            <Typography
                                variant={"body2"}>
                                {lastUserLocation.location.formattedAddress}
                            </Typography>
                            <Stack direction='row' gap={1}>
                                {lastUserLocation.location.isPrecise &&
                                    <Typography
                                        variant={"body1Bold"}>
                                        {date.fromNow()}
                                    </Typography>
                                }
                                <Typography
                                    variant={"body1Bold"}>
                                    ({getPreciseLabel(lastUserLocation)})
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack
                        direction={"column"}
                        sx={{justifyContent: "space-between"}}>
                        <Checkbox
                            color="secondary"
                            onClick={(event) => event.stopPropagation()}
                            onChange={handleToggle(lastUserLocation.personalReference)}
                            checked={checked.indexOf(lastUserLocation.personalReference) !== -1}
                            inputProps={{'aria-labelledby': labelId}}
                        />
                    </Stack>
                </Stack>
            </ListItem>
            {index !== length - 1 &&
                <Divider/>
            }
        </>
    )
}